export default {
  init() {
    // $('.js-tilt').tilt({
    //   glare: true,
    //   maxGlare: .3,
    //   perspective: 1200,
    //   // scale: 1.2,
    // })
    $('.qc-section-layout').each(function(index,item){ //item second item
      // console.log(item);
        $(item)
          .attr('id','section'+index)
        $('#section'+index)
          .viewportChecker({
            classToAdd: 'qc-active', // Class to add to the elements when they are visible,
            classToRemove: 'qc-inactive', // Class to remove before adding 'classToAdd' to the elements
            classToAddForFullView: 'full-visible', // Class to add when an item is completely visible in the viewport
            removeClassAfterAnimation: false, // Remove added classes after animation has finished
            offset: '40%', // The offset of the elements (let them appear earlier or later). This can also be percentage based by adding a '%' at the end
            invertBottomOffset: true, // Add the offset as a negative number to the element's bottom
            repeat: true, // Add the possibility to remove the class if the elements are not visible
            callbackFunction: (item,action) => { // (elem, action)
              if (action === 'remove'){
                $(item).addClass('qc-inactive');
              }
              if ($(item).hasClass('qc-dark-bg')){
                $('body').addClass('qc-light');
              }else{
                $('body').removeClass('qc-light');
              }
              // if (action === 'add'){
              //   // navigatoPosition = index;
              // } else {
              // }
            }, // Callback to do after a class was added to an element. Action will return "add" or "remove", depending if the class was added or removed
            scrollHorizontal: false, // Set to true if your website scrolls horizontal instead of vertical.
        });
    });


    $('[data-slick]').each((index, item) => {
      const $json=JSON.parse($(item).attr('data-slick'));
      $(item).slick($json);
      $(item).on('afterChange',()=> {
        const $curSlide = $(item).find('.slick-active');
        setTimeout( () => {
          $curSlide.addClass('animationClosing');
        }, 3000);
      })
      $(item).on('beforeChange',()=> {
        $(item).find('.slick-active').removeClass('animationClosing');
      })
    });
    // JavaScript to be fired on all pages
    setTimeout(() => {
      $('body').addClass('vp-ready');
    },500);
    $(".hamburger").click(function() {
      $(this).toggleClass("is-active");
    });

    $('[data-toggle-class]').click(function(ev){
      ev.preventDefault();
      $($(this).attr('data-target')).toggleClass($(this).attr('data-toggle-class'));
      var el = this
      setTimeout(function(){      
        $('body').toggleClass('toggled-'+$(el).attr('data-toggle-class'));
      },100)
    });



$('.close').click(function() {
      $('.modal').addClass('modal-close');
    });
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js